document.addEventListener('DOMContentLoaded', () => {
  const checkoutBlock = document.querySelector('shopify-accelerated-checkout');
  if (!checkoutBlock) return;

  const evaluateDelivery = (delivery) => {
    if (delivery.shadowRoot) {
      const hasArrives = delivery.shadowRoot.textContent.includes('Arrives');
      console.log(hasArrives, 'hasArrives');
      checkoutBlock.style = hasArrives ? 'display:block;' : 'display:none; min-height:0, height:0';
    } else {
      checkoutBlock.style = 'display:none; min-height:0, height:0';
    }
  };

  let shadowObserverAttached = false;

  const domObserver = new MutationObserver(() => {
    const delivery = document.querySelector("delivery-promise-wc");
    if (!delivery) return;

    evaluateDelivery(delivery);

    // Attach shadow observer only once
    if (!shadowObserverAttached && delivery.shadowRoot) {
      shadowObserverAttached = true;

      const shadowObserver = new MutationObserver(() => {
        evaluateDelivery(delivery);
      });

      shadowObserver.observe(delivery.shadowRoot, { childList: true, subtree: true, characterData: true });
      domObserver.disconnect(); // No longer need to watch the DOM
    }
  });

  domObserver.observe(document.body, { childList: true, subtree: true });
});